/** Keys for why the zaaksysteem refused a request (reason of zgwRequestFailed / linkFailed). */
const ZGW_REASON_KEYS: Record<string, string> = {
  unauthorized: 'zgw.request.unauthorized',
  forbidden: 'zgw.request.forbidden',
  rejected: 'zgw.request.rejected',
  remoteTooLarge: 'zgw.request.remoteTooLarge',
};

/**
 * The message key for the reason of a failed ZGW request, with a fallback key
 * after it (i18next takes the first key that exists). The reason keys exist in
 * nl only for now: en and de show the fallback.
 */
export const zgwReasonKeys = (error: unknown, fallback: string): string[] => {
  const reason = (error as { data?: { reason?: string } } | undefined)?.data?.reason;
  const key = reason && ZGW_REASON_KEYS[reason];
  return key ? [key, fallback] : [fallback];
};
